// Fixed unused vars
import React, { useState } from "react";
import Modal from "../../ui/Modal";
import { HiUser, HiClock, HiCog, HiShieldCheck } from "react-icons/hi";
import Userdata from "./Userdata";
import UserActivity from "./UserActivity";
import SecuritySettings from "./SecuritySettings"; // Assuming this exists or will be created/imported

const ProfileModal = ({ onClose, initialTab = "profile" }) => {
    const [activeTab, setActiveTab] = useState(initialTab);

    const tabs = [
        { id: "profile", label: "My Profile", icon: HiUser },
        { id: "activity", label: "My Activity", icon: HiClock },
        { id: "account", label: "Account Settings", icon: HiCog },
        { id: "security", label: "Security Settings", icon: HiShieldCheck },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "profile":
                return <Userdata inModal={true} />; // Reusing Userdata for profile view/edit
            case "activity":
                return <UserActivity />;
            case "account":
                return (
                    <div className="p-4">
                        <h3 className="text-lg font-medium text-gray-900 dark:text-white">Account Settings</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400">Manage your account preferences here.</p>
                        {/* Placeholder for AccountSettings if component doesn't exist yet */}
                    </div>
                );
            case "security":
                return <SecuritySettings inModal={true} />;
            default:
                return <Userdata inModal={true} />;
        }
    };

    return (
        <Modal onClose={onClose} title="User Profile" size="large">
            <div className="flex flex-col md:flex-row h-[70vh] md:h-[600px]">
                {/* Sidebar Navigation */}
                <div className="w-full md:w-64 border-b md:border-b-0 md:border-r border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/30 p-2 md:p-4 overflow-x-auto md:overflow-visible flex md:flex-col gap-1 md:gap-2">
                    {tabs.map((tab) => {
                        const Icon = tab.icon;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-all whitespace-nowrap ${activeTab === tab.id
                                    ? "bg-primary text-white shadow-md shadow-primary/20"
                                    : "text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700/50"
                                    }`}
                            >
                                <Icon className={`h-5 w-5 ${activeTab === tab.id ? "text-white" : "text-gray-500 dark:text-gray-400"}`} />
                                {tab.label}
                            </button>
                        );
                    })}
                </div>

                {/* Content Area */}
                <div className="flex-1 overflow-y-auto p-4 md:p-6 bg-white dark:bg-zinc-900">
                    {renderContent()}
                </div>
            </div>
        </Modal>
    );
};

export default ProfileModal;
